export const clientside = {
	update_daterange: function () {
		//console.log("--------------- update_daterange ---------------")
		//console.log(arguments)
		//console.log("update dashboard from update_daterange clientside callback", arguments)
		window.make_dashboard(arguments)
		return window.dash_clientside.no_update
	},
	update_filters: function () {
		//console.log("--------------- update_filters ---------------")
		//console.log(arguments)
		//console.log("update dashboard from update_filters clientside callback", arguments)
		window.filter_dashboard(arguments)

		return window.dash_clientside.no_update
	},
	update_limbo: function () {
		//console.log("update_limbo");
		window.make_limbo();
	},
	update_digest: function () {
		//console.log("update_digest");
		//console.log("arguments", arguments)
		window.WingmanState.digest_events = arguments;
		window.WingmanState.tooltiptimer = setTimeout(function () {
			if (typeof window.make_digest === 'function') {
				window.make_digest(window.WingmanState.digest_events);
			} else {
				console.error('window.make_digest is not available during update_digest');
			}
		}, 1100);
		return true;
	},
	update_timezone_value: function () {
		//console.log("--------------- update_timezone_value ---------------")
		//console.log("update dashboard from timezone_change", arguments)
		const timezoneVal = arguments && arguments.length ? arguments[0] : 'UTC';
		window.change_event_timezone(timezoneVal);
		return window.dash_clientside.no_update;
	},
	add_comment: function () {
		//console.log("add new comment")
		window.add_comment();
	},
	update_explore: function () {
		//console.log("reload_ui_explore");
		//console.log("update explorer from update_filters clientside callback", arguments)
		//make_explore_timeline();
		window.clean_explorer_timeline(arguments);
		if (typeof window.get_filter_event_data === 'function') {
			window.get_filter_event_data();
		} else {
			console.error('window.get_filter_event_data is not available during update_explore');
		}
	},
	update_dataexplorer_daterange: function () {
		//console.log("--------------- update_dataexplorer_daterange ---------------")
		//console.log("update dataexplorer from update_dataexplorer_daterange clientside callback", arguments)
		window._dataexplorer_failsafe_triggered = true;
		if (window._dataexplorer_failsafe_timer) clearTimeout(window._dataexplorer_failsafe_timer);
		window.make_dataexplorer(arguments)
		return window.dash_clientside.no_update
	},
	update_dataexplorer_start_selected: function () {
		//console.log("--------------- update_dataexplorer_start_selected ---------------")
		//console.log("update dataexplorer from update_dataexplorer_start_selected clientside callback", arguments)
		window._dataexplorer_failsafe_triggered = true;
		if (window._dataexplorer_failsafe_timer) clearTimeout(window._dataexplorer_failsafe_timer);
		window.make_dataexplorer_start_selected(arguments)
		return window.dash_clientside.no_update
	},
}

